function classNames(...classes) {
    return classes.filter(Boolean).join(' ') 
}

const ResultadosAlumnos = ({ alumnos, handleAlumno }) => {

    return(
        <>
        <div className="px-4 sm:px-6 lg:px-8 p-5 pb-2 h-full">
            <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto">
                <h1 className="text-lg font-semibold text-white">Resultados</h1>
                <p className="mt-2 text-sm text-grisMira">
                    Listado de alumnos que coinciden con su busqueda.
                </p>
                </div>
            </div>
            <div className="mt-5 flex flex-col p-3 pt-0 pb-5">
                <div className="-mx-4 sm:-mx-6 lg:-mx-8 overflow-auto">
                <div className="inline-block min-w-full align-middle">
                    <div className={`mb-4 h-auto`}>
                    <table className="min-w-full border-separate" style={{ borderSpacing: 0 }}>
                        <thead className="bg-secundarioMira">
                            <tr>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                >
                                    Carnet
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira "
                                >
                                    Alumno
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira hidden lg:table-cell"
                                >
                                    Nit
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira"
                                >
                                    Celular
                                </th>                      
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira"
                                >
                                    Email
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 border-b border-gray-300 py-3.5 pr-4 pl-3 bg-secundarioMira sm:pr-6 lg:pr-8"
                                >
                                <span className="sr-only">Elegir</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-secundarioMira overflow-y-scroll">
                        {alumnos.map((alumno, Idx) =>   
                                <tr 
                                    key={Idx}
                                    onClick={() => handleAlumno(alumno)}
                                    className="cursor-pointer hover:bg-primarioMira"
                                >
                                    <td
                                        className={classNames(
                                        Idx !== alumnos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-white sm:pl-6 lg:pl-8'
                                        )}
                                    >
                                        {alumno.Carnet}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== alumnos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {alumno.Alumno}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== alumnos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white hidden lg:table-cell'
                                        )}
                                    >
                                        {alumno.Nit}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== alumnos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {alumno.Celular}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== alumnos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {alumno.Email}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== alumnos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'relative whitespace-nowrap py-2 pr-4 pl-3 text-right text-sm font-medium sm:pr-6 lg:pr-8'
                                        )}
                                    > 
                                        <button 
                                            type="button"
                                            onClick={() => handleAlumno(alumno)}
                                            className="text-secundario hover:underline"
                                        >
                                            Elegir
                                            <span className="sr-only">, {alumno.Carnet} </span>
                                        </button>
                                    </td>
                                </tr>
                        )}
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default ResultadosAlumnos